import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "tournaments-registration-panel",
  "data-qe-id": "registration-panel"
}
const _hoisted_2 = { class: "registration-info" }
const _hoisted_3 = { class: "tournament-details" }
const _hoisted_4 = { class: "t-text" }
const _hoisted_5 = {
  key: 1,
  class: "t-inlay-tip t-tc"
}

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import CTournamentInfo from '@/components/CTournamentInfo.vue'
import { TournamentStatus } from '@/model/TournamentStatus'
import { TournamentUi } from '@/model/Tournament'
import { DateFormat } from '@gd/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'CTournamentRegistrationPanel',
  props: {
    tournamentUi: {}
  },
  emits: ['register'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const { d } = useI18n()

function register(blocked: boolean) {
  if (blocked) {
    return
  }
  if (registrationPossible.value) emit('register')
}

const registrationStart = computed(() => {
  return d(new Date(props.tournamentUi.dates.registrationStart), DateFormat.DDMMYYY)
})
const registrationPossible = computed(() => {
  return props.tournamentUi.isRegistrationPossible
})
/**
 * the case that the registration time ended and a tournament is not
 * in running mode is not handled ( because it should not happen )
 */
const registrationIsOver = computed(() => {
  return !(registrationPossible.value || props.tournamentUi.tournamentStatus === TournamentStatus.UPCOMING)
})

return (_ctx: any,_cache: any) => {
  const _component_t_button = _resolveComponent("t-button")!
  const _component_t_tooltip = _resolveComponent("t-tooltip")!
  const _component_c_tech_hint = _resolveComponent("c-tech-hint")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["tournament-details--image", _ctx.tournamentUi.metaData.image])
        }, null, 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.tournamentUi.name), 1),
          _createVNode(CTournamentInfo, {
            "tournament-ui": _ctx.tournamentUi,
            class: "tournament-info-box",
            gameName: "",
            totalWin: "",
            addedPrize: "",
            entryFee: "",
            restartFee: "",
            competitionDateLobbyTime: "",
            registrationDate: ""
          }, null, 8, ["tournament-ui"])
        ])
      ]),
      (!registrationIsOver.value)
        ? (_openBlock(), _createBlock(_component_c_tech_hint, {
            key: 0,
            class: "c-tech-button",
            gametype: _ctx.tournamentUi.gametype,
            techs: _ctx.tournamentUi.metaData.gameTechs
          }, {
            default: _withCtx((status) => [
              _createVNode(_component_t_tooltip, {
                disabled: registrationPossible.value || status.block,
                text: 
              _ctx.$t('tViews.registrationInfo.registrationDidNotStart_info', {
                registrationStart: registrationStart.value,
              })
            
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_t_button, {
                    yellow: "",
                    l: "",
                    inactive: status.block,
                    disabled: !(registrationPossible.value || status.block),
                    onClick: ($event: any) => (register(status.block)),
                    "data-qe-id": "register-button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('tViews.registrationInfo.button')), 1)
                    ]),
                    _: 2
                  }, 1032, ["inactive", "disabled", "onClick"])
                ]),
                _: 2
              }, 1032, ["disabled", "text"])
            ]),
            _: 1
          }, 8, ["gametype", "techs"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('tViews.registrationInfo.registrationTimeOver')), 1))
    ])
  ]))
}
}

})